import React from 'react';
import { Link } from "react-router-dom"
import { Jumbotron } from 'react-bootstrap'

const GetMetamask = () => (
    <Jumbotron className="text-center">
        <h3>MetaMask brings Ethereum to your browser.</h3>
        <Link to="https://metamask.io/"><h5>Get Metamask</h5></Link>
        <h5>Please switch to MetaMask Rinkeby Test Network</h5>
        <p>Useful link: <Link to="https://metamask.io/">metamask.io</Link></p>
    </Jumbotron>
)

export default GetMetamask